const styles = {
    '.LayoutContainer': {
        height: 'calc(100vh - 60px)',
        overflowY: 'auto'
    }
}

export default styles;